import { Container, FillGradient, Graphics } from 'pixi.js'
import type { Orientation, Resizable } from '../../framework/render/design'

// 背景底色（櫻花粉漸層）— 作為基底/後備；真實場景由 SpineSceneView 疊在其上。
export class BackgroundView extends Container implements Resizable {
  private readonly sky = new Graphics()

  constructor() {
    super()
    this.addChild(this.sky)
  }

  resize(width: number, height: number, _orientation: Orientation): void {
    const gradient = new FillGradient({
      type: 'linear',
      start: { x: 0, y: 0 },
      end: { x: 0, y: height },
    })
    gradient.addColorStop(0, 0xf9dbe7)
    gradient.addColorStop(0.55, 0xe7c7e6)
    gradient.addColorStop(1, 0xb9a8e0)
    this.sky.clear()
    this.sky.rect(0, 0, width, height).fill(gradient)
  }
}
